import {useAiChat} from '@AiChat/providers/ai-chat.context';
import {getAiChatSeasonForPage} from '@AiChat/lib/ai-chat-season-library';
import type {AiChatSeason} from '@AiChat/lib/ai-chat-season-library.types';

export function useAiChatSeason(): AiChatSeason | null {
  const {state} = useAiChat();

  return getAiChatSeasonForPage(state);
}
